/* eslint-disable no-template-curly-in-string */
export default {
  HRready: 'HRready',
  'Conversation 自测': 'Conversation self-test',
  页面未找到: 'Page not found',
  地推登录: 'Field promotion login',
  地推人员不存在: 'Field staff member not found',
  地推邀请码: 'Promotion codes',
  地推业绩: 'Promotion performance',
  招聘者审核详情: 'Recruiter review details',
  用户审核: 'User reviews',
  'HRready Invitation': 'HRready Invitation',
  'Campaign rules': 'Campaign rules',
  'HRready User Agreement': 'HRready User Agreement',
  'Privacy Policy': 'Privacy Policy',
  'AI & Automated Services Notice': 'AI & Automated Services Notice',
  'Communications & AI Calls Policy': 'Communications & AI Calls Policy',
  'California Privacy Notice': 'California Privacy Notice',
  'Campaign rules | HRready': 'Campaign rules | HRready',
  'Legal Documents | HRready': 'Legal Documents | HRready',
  'Privacy Policy | HRready': 'Privacy Policy | HRready',
  'HRready User Agreement | HRready': 'HRready User Agreement | HRready',
  'AI & Automated Services Notice | HRready': 'AI & Automated Services Notice | HRready',
  'Communications & AI Calls Policy | HRready': 'Communications & AI Calls Policy | HRready',
  'California Privacy Notice | HRready': 'California Privacy Notice | HRready',
  下拉刷新: 'Pull to refresh',
  释放立即刷新: 'Release to refresh',
  刷新成功: 'Refreshed',
  '${name} invited you': '${name} invited you',
  'Your AI job assistant, always ready': 'YOUR AI JOB ASSISTANT, ALWAYS READY',
  'Free to register': 'Free to register',
  'Always-on matching': 'Always-on matching',
  'You stay in control': 'You stay in control',
  'Referral rewards': 'Referral rewards',
  '${amount} EACH': '${amount} EACH',
  'UP TO ${amount}': 'UP TO ${amount}',
  '${amount} cash reward for each qualified new job seeker sign-up.':
    '${amount} cash reward for each qualified new job seeker sign-up.',
  'AI job assistant': 'AI job assistant',
  'Your search keeps moving': 'Your search keeps moving',
  "The person who invited you can't see your phone number, work history, or applications.":
    "The person who invited you can't see your phone number, work history, or applications.",
  'Register free and start searching': 'Register free and start searching',
  'In as little as ${hours} hours': 'In as little as ${hours} hours',
  '${hours}h': '${hours}h',
  'Refer ${count}, get': 'Refer ${count}, get',
  '${amount} per hour': '${amount} per hour',
  'in ${hours}h.': 'in ${hours}h.',
  'Paid after registration, verification, and eligibility review. No reward for non-genuine job-search sign-ups, duplicate accounts, or suspicious activity.':
    'Paid after registration, verification, and eligibility review. No reward for non-genuine job-search sign-ups, duplicate accounts, or suspicious activity.',
  'Start in about ${seconds} seconds': 'Start in about ${seconds} seconds',
  'Create your HRready account': 'Create your HRready account',
  'Close registration': 'Close registration',
  'Invitation relationship connected': 'Invitation relationship connected',
  'Registration successful': 'Registration successful',
  'Your account is connected to this invitation. Eligibility and rewards are determined by platform review records.':
    'Your account is connected to this invitation. Eligibility and rewards are determined by platform review records.',
  'Registration completed normally without an invitation relationship.':
    'Registration completed normally without an invitation relationship.',
  'US mobile number': 'US mobile number',
  'Enter your mobile number': 'Enter your mobile number',
  'Verification code': 'Verification code',
  'Enter the verification code': 'Enter the verification code',
  'Enter code': 'Enter code',
  'Send code': 'Send code',
  'Resend in ${countdown}s': 'Resend in ${countdown}s',
  'Please accept the agreements': 'Please accept the agreements',
  'Failed to load the agreements. Please try again later.': 'Failed to load the agreements. Please try again later.',
  'Failed to send the code. Please try again later.': 'Failed to send the code. Please try again later.',
  'Verification code sent': 'Verification code sent',
  'Send a verification code first': 'Send a verification code first',
  'Better jobs, closer to home': 'Better jobs, closer to home',
  YOUR: 'YOUR',
  'NEXT PAYCHECK': 'NEXT PAYCHECK',
  'IS CLOSER': 'IS CLOSER',
  'THAN YOU THINK.': 'THAN YOU THINK.',
  'Up to': 'Up to',
  'per hour': 'per hour',
  'Get hired in': 'Get hired in',
  'Close to home': 'Close to home',
  'walk to work': 'walk to work',
  'HRready — your AI job-search assistant.': 'HRready — your AI job-search assistant.',
  'REGISTER NOW': 'REGISTER NOW',
  'Get hired': 'Get hired',
  'Jobs close to home': 'Jobs close to home',
  'Find nearby work that fits your schedule': 'Find nearby work that fits your schedule',
  'Earn more': 'Earn more',
  'Discover better-paying hourly jobs': 'Discover better-paying hourly jobs',
  'Fast matching': 'Fast matching',
  'Apply once, keep matching': 'Apply once, keep matching',
  'Tell us what you want. AI keeps searching.': 'Tell us what you want. AI keeps searching.',
  'Communicate for you': 'Communicate for you',
  'Make phone calls and organize information to reduce repetitive filling out and confirmation processes.':
    'Make phone calls and organize information to reduce repetitive filling out and confirmation processes.',
  'Promotion process': 'Promotion process',
  'Submit job applications, contact candidates, and follow up on interview progress.':
    'Submit job applications, contact candidates, and follow up on interview progress.',
  "I'll contact you when I need it.": "I'll contact you when I need it.",
  'When confirmation or authorization is required, HRready will remind you to proceed.':
    'When confirmation or authorization is required, HRready will remind you to proceed.',
  'When confirmation or authorization is required, a card will remind you to proceed.':
    'When confirmation or authorization is required, a card will remind you to proceed.',
  'Open HRready': 'Open HRready',
  'Open the app and let AI understand your goals.': 'Open the app and let AI understand your goals.',
  'Open the web version or download the app, and select "Find a job" or "Recruit someone".':
    'Open the web version or download the app, and select "Find a job" or "Recruit someone".',
  'Answer AI calls': 'Answer AI calls',
  'Clearly state the opportunities and preferences.': 'Clearly state the opportunities and preferences.',
  'Clearly state the requirements and key conditions.': 'Clearly state the requirements and key conditions.',
  'View progress': 'View progress',
  'Track your applications, interviews, and next steps.': 'Track your applications, interviews, and next steps.',
  'Confirm the application, candidates, and interview arrangements.':
    'Confirm the application, candidates, and interview arrangements.',
  'JOB HUNTING\nOR HIRING.\nLEAVE IT TO HRREADY.': 'JOB HUNTING\nOR HIRING.\nLEAVE IT TO HRREADY.',
  'AI Job Search and Recruitment Assistant': 'AI Job Search and Recruitment Assistant',
  'iOS Download': 'iOS Download',
  'Android Download': 'Android Download',
  'What will HRready\ndo for you?': 'What will HRready\ndo for you?',
  'Three steps to begin': 'Three steps to begin',
  'Delegate repetitive tasks to HRready, and make the key decisions yourself.':
    'Delegate repetitive tasks to HRready, and make the key decisions yourself.',
  'Every step is recorded and can be viewed or taken over at any time.':
    'Every step is recorded and can be viewed or taken over at any time.',
  'Download APP': 'Download APP',
  地推助手: 'Field Promotion Assistant',
  上午好: 'Good morning',
  工作中: 'Active',
  已暂停: 'Paused',
  入职中: 'Onboarding',
  邀请码: 'Invitation Code',
  业绩: 'Performance',
  退出: 'Sign Out',
  登录: 'Sign In',
  登录地推工作台: 'Sign in to the Field Promotion Workspace',
  登录方式: 'Sign-in Method',
  '登录已失效，正在返回登录页': 'Your session has expired. Returning to sign in.',
  '登录中...': 'Signing in...',
  发送中: 'Sending',
  工作邮箱: 'Work Email',
  欢迎回来: 'Welcome Back',
  获取验证码: 'Get Code',
  记住登录状态: 'Keep Me Signed In',
  密码: 'Password',
  密码登录: 'Password Sign-in',
  密码登录账号类型: 'Password Sign-in Account Type',
  '密码通过加密连接提交，平台不会展示密码':
    'Your password is sent over an encrypted connection and is never displayed by the platform.',
  '请输入 4 位验证码': 'Enter the 4-digit code',
  请输入密码: 'Enter your password',
  请输入手机号: 'Enter your mobile number',
  请输入邮箱: 'Enter your email',
  请输入正确的邮箱: 'Enter a valid email address',
  '请输入至少 8 位密码': 'Enter a password with at least 8 characters',
  请先获取验证码: 'Get a verification code first',
  使用手机号或邮箱密码登录: 'Sign in with a mobile number or email and password',
  使用手机号验证码快速登录: 'Sign in quickly with a mobile verification code',
  手机号: 'Mobile Number',
  显示密码: 'Show Password',
  验证码登录: 'Verification Code',
  验证码仅发送至已开通的地推手机号: 'Codes are sent only to mobile numbers enabled for field promotion.',
  邮箱: 'Email',
  隐藏密码: 'Hide Password',
  账号安全保护: 'Account Security',
  账号或密码错误: 'Incorrect account or password',
  验证码: 'Verification code',
  请输入验证码: 'Enter the verification code',
  '验证码发送失败，请稍后重试': 'Failed to send the code. Please try again later.',
  验证码不正确或已失效: 'The verification code is incorrect or has expired',
  '登录状态确认失败，请重试': 'Unable to confirm your session. Please try again.',
  重新加载: 'Reload',
  二维码: 'QR Code',
  '二维码包含你的 HRready 地推邀请链接': 'The QR code contains your HRready field promotion invitation link.',
  分享邀请码或二维码: 'Share an invitation code or QR code',
  复制邀请码: 'Copy Invitation Code',
  后续进度在业绩页查看: 'Track subsequent progress on the Performance page.',
  让新用户在注册时填写此邀请码: 'Ask new users to enter this invitation code when registering.',
  扫码使用我的邀请码: 'Scan to Use My Invitation Code',
  推广码展示方式: 'Promotion Code Display',
  完成注册验证: 'Complete Registration Verification',
  我的推广码: 'My Promotion Code',
  '向新用户展示邀请码或二维码，注册时即可关联你的推广来源。':
    'Show new users your invitation code or QR code so their registration can be attributed to your promotion source.',
  新用户注册并通过验证: 'New User Registers and Is Verified',
  邀请更多用户加入: 'Invite More Users',
  邀请码加载中: 'Loading invitation code',
  邀请码已复制: 'Invitation code copied',
  '邀请码用于提出来源归因，最终业绩以平台验证记录为准。':
    'Invitation codes indicate the proposed source attribution. Final performance is based on platform-verified records.',
  展示推广码: 'Show Promotion Code',
  '注册、匹配、面试和结算进度，一部手机随时查看。':
    'Track registration, matching, interviews, and settlement progress anytime from your phone.',
  计入业绩进展: 'Count Toward Performance',
  随时掌握你的: 'Stay on Top of Your',
  'MY PROMOTION CODE': 'MY PROMOTION CODE',
  推广码加载失败: 'Unable to load the promotion code',
  '请检查网络后重试，当前未切换为手工邀请码。':
    'Check your connection and try again. A manual invitation code has not been substituted.',
  完成普通邀请: 'Complete a standard invitation',
  '当前无活动推广码，不承诺计入活动业绩':
    'There is no active campaign code, so campaign performance is not guaranteed.',
  '${count} 条': '${count} items',
  '${value}年': 'Year ${value}',
  '${value}月': 'Month ${value}',
  '${value}日': 'Day ${value}',
  '查看全部 ${count} 条': 'View all ${count}',
  '查看邀请用户从注册到面试的进度，以及对应结算金额。':
    'Track invited users from registration through interviews, along with the corresponding settlement amounts.',
  从注册到确认面试: 'From Registration to Confirmed Interview',
  待结算: 'Pending Settlement',
  待结算收入: 'Pending Earnings',
  '待结算收入加载失败，请稍后重试': 'Unable to load pending earnings. Please try again later.',
  待结算收入加载中: 'Loading pending earnings',
  待支付: 'Pending Payment',
  当前日期范围内暂无待结算收入: 'No pending earnings in the selected date range.',
  归属招聘者: 'Assigned Recruiter',
  加载中: 'Loading',
  取消: 'Cancel',
  结束日期: 'End Date',
  结算概览: 'Settlement Overview',
  结算收入与财务回传实时汇总: 'Live summary of settlement earnings and finance payment results',
  '结算数据加载失败，请稍后重试': 'Unable to load settlement data. Please try again later.',
  结算数据加载中: 'Loading settlement data',
  开始日期: 'Start Date',
  可参与匹配: 'Ready for Matching',
  累计业绩金额: 'Total Performance Amount',
  默认最近七天: 'Last 7 Days by Default',
  全部来源: 'All Sources',
  确认: 'Confirm',
  确认面试: 'Interview Confirmed',
  收起: 'Show Less',
  '数据截至 ${date}': 'Data as of ${date}',
  数据来自结算收入事实与财务付款结果: 'Data is based on settlement earnings records and finance payment results.',
  实时快照: 'Live Snapshot',
  我的业绩: 'My Performance',
  下一页: 'Next',
  验证注册: 'Verified Registration',
  业绩概览: 'Performance Overview',
  业绩区间: 'Performance Period',
  '业绩数据加载失败，请稍后重试': 'Unable to load performance data. Please try again later.',
  业务时区: 'Business Time Zone',
  已支付累计: 'Total Paid',
  '预计解冻 ${date}': 'Expected to be released on ${date}',
  至: 'to',
  注册时间: 'Registration Time',
  转化进度: 'Conversion Progress',
  总金额: 'Total Amount',
  最近进展: 'Recent Progress',
  '操作未完成，请检查网络后重试': 'The action could not be completed. Check your connection and try again.',
  创建审核: 'Review Created',
  待补充: 'Needs Additional Information',
  待审核: 'Pending Review',
  当前账号没有招聘者审核权限: 'This account does not have permission to review recruiters.',
  地推邀请: 'Field Promotion Invitation',
  该招聘者已不在你的当前归属范围内: 'This recruiter is no longer within your assigned scope.',
  企业: 'Company',
  企业信息待完善: 'Company information incomplete',
  全部状态: 'All Statuses',
  审核: 'Review',
  审核不通过: 'Rejected',
  '审核不通过 · 待补充': 'Rejected · Additional Information Needed',
  '审核服务或附件存储暂不可用，请稍后重试':
    'The review service or attachment storage is temporarily unavailable. Please try again later.',
  审核通过: 'Approved',
  审核状态: 'Review Status',
  市场: 'Market',
  市场待完善: 'Market information incomplete',
  '提交内容不符合要求，请检查后重试':
    'The submitted information does not meet the requirements. Review it and try again.',
  提交审核: 'Submit for Review',
  退回补充: 'Return for Additional Information',
  未分配: 'Unassigned',
  未提供: 'Not Provided',
  邀请: 'Invitation',
  用户来源: 'User Source',
  资料完善: 'Profile Completed',
  '资料保存、提交和审核决定分别记录，审核只针对已提交版本。':
    'Saving, submission, and review decisions are recorded separately. Reviews apply only to submitted versions.',
  资料待上传: 'Documents Pending Upload',
  '资料已被更新，请刷新后重新操作': 'The information has been updated. Refresh the page and try again.',
  资料已提交审核: 'Information submitted for review',
  自然流量: 'Organic Traffic',
  返回用户列表: 'Back to User List',
  重试: 'Try Again',
  '第 ${page} / ${totalPages} 页 · 共 ${total} 人': 'Page ${page} of ${totalPages} · ${total} people total',
  查看资料: 'View Information',
  '仅展示当前归属招聘者，改派后原负责人立即失去访问权限':
    'Only recruiters currently assigned to you are shown. The previous owner loses access immediately after reassignment.',
  没有符合筛选条件的招聘者: 'No recruiters match the filters.',
  审核用户分页: 'Review User Pagination',
  '审核用户加载失败，请检查网络后重试': 'Unable to load users for review. Check your connection and try again.',
  搜索招聘者: 'Search Recruiters',
  上一页: 'Previous',
  完善资料: 'Complete Information',
  '姓名、用户 ID、手机号、企业或市场': 'Name, user ID, mobile number, company, or market',
  用户审核筛选: 'User Review Filters',
  招聘者详情: 'Recruiter Details',
  '正在加载审核用户...': 'Loading users for review...',
  状态待确认: 'Status Pending Confirmation',
  保存并提交审核: 'Save and Submit for Review',
  保存资料: 'Save Information',
  必填: 'Required',
  补充说明: 'Additional Notes',
  补充资料要求: 'Additional Information Required',
  查看审核资料: 'View Review Information',
  当前版本附件: 'Current Version Attachments',
  当前归属: 'Current Assignment',
  '附件不能超过 10 MB': 'Attachments cannot exceed 10 MB.',
  '附件上传失败，请检查文件后重试': 'Unable to upload the attachment. Check the file and try again.',
  '附件下载失败，请稍后重试': 'Unable to download the attachment. Please try again later.',
  '附件已上传，请保存资料以关联到当前版本':
    'Attachment uploaded. Save the information to associate it with the current version.',
  '每个资料版本最多关联 10 个附件': 'Each information version can include up to 10 attachments.',
  '仅支持 PDF、JPG 和 PNG 文件': 'Only PDF, JPG, and PNG files are supported.',
  审核版本: 'Review Version',
  审核不通过时必填: 'Required when rejecting a review',
  '审核不通过原因 / 补充要求': 'Reason for Rejection / Additional Requirements',
  '审核决定固定使用已提交版本，不能在本区编辑或替换资料。':
    'The review decision is based on the submitted version. Information cannot be edited or replaced in this section.',
  审核已通过: 'Review approved',
  审核招聘者资料: 'Review Recruiter Information',
  '审核状态不修改职位状态，仅作为候选端可见性和自动匹配的资格依据。':
    'Review status does not change job status. It only determines candidate-side visibility and eligibility for automatic matching.',
  审核资料: 'Review Information',
  审核资料已保存: 'Review information saved',
  刷新资料: 'Refresh Information',
  上传附件: 'Upload Attachment',
  '上传中...': 'Uploading...',
  填写并上传资料: 'Complete and Upload Information',
  '下载 ${filename}': 'Download ${filename}',
  '移除 ${filename}': 'Remove ${filename}',
  已提交资料: 'Submitted Information',
  已退回补充资料: 'Returned for additional information',
  用户基础信息: 'Basic User Information',
  暂未关联附件: 'No attachments associated yet',
  暂无审核记录: 'No review history yet',
  招聘者审核资料: 'Recruiter Review Information',
  '招聘者审核资料加载失败，请检查网络后重试':
    "Unable to load the recruiter's review information. Check your connection and try again.",
  正在加载招聘者资料: 'Loading recruiter information',
  '支持 PDF、JPG、PNG，单个不超过 10 MB': 'PDF, JPG, and PNG files are supported, up to 10 MB each.',
  只读审核依据: 'Read-only Review Basis',
  '注册于 ${date}': 'Registered on ${date}',
  资料: 'Information',
  资料版本与审核记录: 'Information Versions and Review History',
  资料编号: 'Document Number',
  资料名称: 'Document Name',
  资料语言: 'Information Language',
  最近更新: 'Last Updated',
  最新资料版本: 'Latest Information Version',
};
